module.exports = __webpack_public_path__ + "img/icon-vk.55a86b71.svg";